import { extractCssStyle } from '../../utilities';

export interface MarginStylingProps {
  margin?: string;
  marginBottom?: string;
  marginTop?: string;
  marginLeft?: string;
  marginRight?: string;
}

export const MarginStyling = (props: MarginStylingProps) => extractCssStyle(props);
